export default __webpack_public_path__ + "3b91769c57c414ae89bd55a87d8baf95.svg";